exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods-manage-tabs[data-v-08620ffb]{padding:12px}", ""]);

// exports
